import { ChangeDetectorRef, Directive, EventEmitter, Output } from '@angular/core';

import { WindowRefService } from '@hdms/shared/util-core';

@Directive()
export abstract class VisibilityComponentAbstract {
  set isHidden(isHidden: boolean) {
    if (isHidden !== this.isComponentHidden) {
      this.isComponentHidden = isHidden;
      this.onVisibilityChange();
    }
  }

  get isHidden(): boolean {
    return this.isComponentHidden;
  }

  get isOpen(): boolean {
    return this.isComponentOpen;
  }

  set isOpen(isOpen: boolean) {
    if (isOpen !== this.isComponentOpen) {
      this.isComponentOpen = isOpen;
      this.onVisibilityChange();
    }
  }

  private readonly raf = this.win.nativeWindow.requestAnimationFrame;
  private isComponentHidden = true;
  private isComponentOpen = false;

  @Output() closed = new EventEmitter<void>();

  protected constructor(protected readonly win: WindowRefService, protected readonly cdr: ChangeDetectorRef) {}

  toggle(): void {
    this.isOpen ? this.close() : this.open();
  }

  close(): void {
    this.isOpen = false;
  }

  open(): void {
    this.isHidden = false;
    this.onNextFrame(() => (this.isOpen = true));
  }

  protected onVisibilityChange(): void {
    this.cdr.markForCheck();
  }

  protected onClosed(): void {
    this.isHidden = true;
    this.closed.emit();
  }

  private onNextFrame(callbackFn: () => void): void {
    this.raf(() => this.raf(callbackFn));
  }
}
